import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-working-progress',
  templateUrl: './working-progress.component.html',
  styleUrls: ['./working-progress.component.scss']
})
export class WorkingProgressComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
